const WORDS = ["S'informer", "Comprendre", "Se préparer", "Agir"];

export default function Marquee() {
  const row = [...WORDS, ...WORDS, ...WORDS, ...WORDS];
  return (
    <div className="relative overflow-hidden border-y border-slate-100 bg-slate-50/60 py-5" aria-hidden>
      <div className="animate-marquee flex w-max items-center gap-10 whitespace-nowrap">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center gap-10">
            {row.map((w, i) => (
              <span key={`${half}-${i}`} className="flex items-center gap-10">
                <span className="font-display text-lg font-bold uppercase tracking-[0.25em] text-slate-300">{w}</span>
                <span className={`h-2 w-2 rotate-45 ${i % 3 === 0 ? "bg-bleu/40" : i % 3 === 1 ? "bg-rouge/40" : "bg-emeraude/40"}`} />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
